import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ManagedDepartmentFragment } from '@api/fragments'
import { IManagedDepartment } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface AddDepartmentAdminEmployeeInput {
  id: string
  departmentId: string
}

interface IPayload {
  addDepartmentAdminEmployee: {
    employee: {
      departmentAdmins: IManagedDepartment[]
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, IManagedDepartment[]>({
  handler: (data) => data.addDepartmentAdminEmployee.employee.departmentAdmins,
  name: 'Department',
})

export default function addDepartmentToManagedDepartments(
  input: AddDepartmentAdminEmployeeInput
): Promise<IManagedDepartment[]> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation AddDepartmentToManagedDepartments($input: AddDepartmentAdminEmployeeInput!) {
    addDepartmentAdminEmployee(input: $input) {
      employee {
        departmentAdmins {
          department {
            ...ManagedDepartmentFragment
          }
        }
      }
    }
  }
  ${ManagedDepartmentFragment}
`
